import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper'
import Button from 'material-ui/Button'
import Paper from 'material-ui/Paper'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import { FormControl, FormHelperText } from 'material-ui/Form'
import Table, {
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from 'material-ui/Table'
import Select from 'material-ui/Select'

class Q4 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      popCount1: 'Loading...',
      popCount2: 'Loading...'
    }
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value })
  }

  getDistribution() {
    //alert(this.props.old_age)
    if (this.props.old_age < 35 || this.props_old_age > 65) {
      alert('Please select a preferred age within the range of 35 and 65.')
      this.props.changeRoute('/console/display/adhoc_filters/question4')
    } else {
      let currentComponent = this
      let url =
        'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/70/agelow/0/oarhigh/10/oarlow/0/herprefage/' +
        this.props.old_age +
        '/herprefans/0/clrhigh/5/clrlow/1/education/0/income/0/cust/' +
        this.props.customer_number
      let url1 =
        'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/70/agelow/0/oarhigh/10/oarlow/0/herprefage/' +
        this.props.old_age +
        '/herprefans/1/clrhigh/5/clrlow/1/education/0/income/0/cust/' +
        this.props.customer_number

      axios.get(url).then(function(response) {
        if (response.data[0]['SearchCount']) {
          axios.get(url1).then(function(response2) {
            if (response2.data[0]['SearchCount']) {
              currentComponent.setState({
                popCount1: response2.data[0]['SearchCount'],
                popCount2: response.data[0]['SearchCount'],
                loaded: true
              })
            } else {
              currentComponent.getDistribution()
            }
          })
        } else {
          currentComponent.getDistribution()
        }
      })
    }
  }

  componentDidMount() {
    this.getDistribution()
  }

  render() {
    const { classes, theme, location } = this.props

    if (this.state.loaded) {
      return (
        <div className={classes.root}>
          <Typography>
            Heres a breakdown of the distribution of the preferred age:{' '}
            {this.props.old_age}
          </Typography>
          <br />
          <br />
          <Typography type="body2">
            Include only candidates that gave an answer:
          </Typography>
          <Typography>{this.state.popCount1}</Typography>
          <br />
          <Typography type="body2">
            Include filtered candidates that DID NOT give an answer:
          </Typography>
          <Typography>{this.state.popCount2}</Typography>
          <br />
          <div className={classes.buttonNext}>
            <Button
              raised
              onClick={() =>
                this.props.changeRoute(
                  '/console/display/adhoc_filters/question4'
                )
              }
              color="primary"
              align="center"
              className={classes.button}
            >
              Go Back
            </Button>
          </div>
        </div>
      )
    } else {
      return (
        <div className={classes.root}>
          <Typography>
            Heres a breakdown of the distribution of the preferred age:{' '}
            {this.props.old_age}
          </Typography>
          <br />
          <br />
          <Typography type="body2">
            Include only candidates that gave an answer:
          </Typography>
          <Typography>Loading...</Typography>
          <br />
          <Typography type="body2">
            Include filtered candidates that DID NOT give an answer:
          </Typography>
          <Typography>Loading...</Typography>
          <br />
          <div className={classes.buttonNext}>
            <Button
              raised
              onClick={() =>
                this.props.changeRoute(
                  '/console/display/adhoc_filters/question4'
                )
              }
              color="primary"
              align="center"
              className={classes.button}
            >
              Go Back
            </Button>
          </div>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    old_age: state.adhoc_old_age
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Q4)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Distribution/Q4/index.js